import * as types from './actionTypes';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import { FUNDING_APP_BASE_URL } from '../constants/global';
import { generateURL } from '../api/urlHelper';
import {fetchParams} from '../constants/fetchParams';

export function receiveContactsData(json) {
  return {type: types.FETCH_CONTACTS, contacts: json};
}

function contactsUrl(partner) {
  return generateURL(`${FUNDING_APP_BASE_URL()}company_resources`, partner);
}

export function fetchContacts(partner) {
  return dispatch => {
    return authenticatedFetch(contactsUrl(partner), fetchParams())
    .then(response => response.json())
    .then(json => dispatch(receiveContactsData(json)));
  };
}
